export default "__VITE_ASSET__WosPIS5E__"